import callCmAPI from 'services/helpers/call-cm-api'
import { BannerT, CreateBannerDataT, WebApi2Response } from 'types/global'

/**
 * Creates a new banner.
 *
 * Mirrors the customer-group create service — `created_by` is filled
 * server-side from the Firebase token, so it's never sent from the
 * client. Validation failures (empty audience, missing required
 * locales, invalid schedule window) surface as 400s; the mutation
 * hook converts them into snackbars.
 */
export const createBanner = (
  body: CreateBannerDataT,
): Promise<WebApi2Response<BannerT>> =>
  callCmAPI('/banner', {
    method: 'post',
    data: body,
  }).then(({ data }) => {
    return data
  })
